<div class="closing-x-wrap">
    <mat-icon class="close-icon condenced" alt="Close dialog" (click)="close()"> close </mat-icon>
</div>
<h1 mat-dialog-title id="signature-title">Add Co-Buyer</h1>
<div mat-dialog-content>
    <form [formGroup]="form" (ngSubmit)="addCoBuyer()">
        <ng-container *ngIf="foundUser">
            <p *ngIf="!userIsBuyer && !userIsNotCustomer" class="user-found">
                Customer found! Is this the right person? If not, please verify and re-enter the email address. If it is the right person but some of their
                information needs to be updated, the customer can do that through the profile screen when they log in.
            </p>
            <p *ngIf="userIsBuyer" class="user-found">The email address is already associated to the buyer on the deal. Please enter a different one.</p>
            <p *ngIf="userIsNotCustomer" class="user-found">This email address is associated with another account. Please enter a different one.</p>
        </ng-container>
        <div class="row">
            <mat-form-field class="col" appearance="fill">
                <mat-label>Email*</mat-label>
                <mat-placeholder>Email</mat-placeholder>
                <input class="form-control" matInput formControlName="email" data-test="add-cobuyer-modal-email" />
                <mat-error>Invalid Email Address</mat-error>
            </mat-form-field>

            <mat-form-field class="col" appearance="fill">
                <mat-label>Mobile Phone*</mat-label>
                <input
                    class="form-control"
                    type="text"
                    matInput
                    appPhoneMask
                    formControlName="phone"
                    id="phone-number"
                    placeholder="(XXX) XXX-XXXX"
                    maxlength="14"
                />
                <mat-error>Invalid Phone Number</mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col" appearance="fill">
                <mat-label>First Name*</mat-label>
                <mat-placeholder>First Name</mat-placeholder>
                <input class="form-control" type="text" matInput formControlName="firstName" />
                <mat-error>Invalid First Name</mat-error>
            </mat-form-field>

            <mat-form-field class="col" appearance="fill">
                <mat-label>Middle Initial</mat-label>
                <mat-placeholder>Middle Initial</mat-placeholder>
                <input class="form-control" type="text" matInput formControlName="middleName" required="false" />
                <mat-error>Invalid Middle Initial</mat-error>
            </mat-form-field>

            <mat-form-field class="col" appearance="fill">
                <mat-label>Last Name*</mat-label>
                <mat-placeholder>Last Name</mat-placeholder>
                <input class="form-control" type="text" matInput formControlName="lastName" />
                <mat-error>Invalid Last Name</mat-error>
            </mat-form-field>
        </div>

        <ng-container>
            <div class="buttons">
                <button mat-button (click)="close()" type="button" class="secondary">Cancel</button>
                <button mat-button type="submit" class="primary" [disabled]="userIsBuyer || userIsNotCustomer">Add Co-Buyer</button>
            </div>
        </ng-container>
    </form>
</div>
